<template>
    <div class="main-content text-left">
        <div class="row">
            <div class="col-md-12 col-lg-8 row mx-0 align-items-start" v-if="testimonials.length">
                <div class="row mx-0 col-12" v-for="(testimonial, index) in testimonials"
                    :key="index">
                    <div class="col-md-6 mb-5">
                        <img :src="testimonial.image_url" class="img-fluid" :alt="`${testimonial.title.rendered}'s Testimonial`">
                    </div>
                    <div class="content-details text-normal col-md-6">
                        <div v-html="testimonial.content.rendered"></div>
                        <div class="text-normal font-bold mt-2">
                            - {{ testimonial.title.rendered }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 d-none d-lg-block fixed-images-list" v-if="testimonials.length">
                <img src="../../assets/testimonials/testimonial_4.png" class="img-fluid col-md-10 mb-2" alt="Testimonial 4">
                <img src="../../assets/testimonials/testimonial_3.png" class="img-fluid col-md-10 mb-2" alt="Testimonial 3">
                <img src="../../assets/testimonials/testimonial_5.png" class="img-fluid col-md-10 mb-2" alt="Testimonial 5">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TestimonialsDetails',
    computed: {
        testimonials() {
            return this.$store.state.testimonials
        }
    }
}
</script>
